import { RouteProp, useRoute } from "@react-navigation/native";
import { Suspense, useEffect } from "react";
import { StatusBar } from "react-native";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import { ClubStackNavigatorParamList } from "../../navigators/ClubNavigator";
import {
  AgendaFromFacilityTypePatron,
  AgendaFromFacilityTypeQueryString,
} from "./AgendaFromFacilityTypePatron";
import { AgendaFromFacilityTypePatronQuery } from "./__generated__/AgendaFromFacilityTypePatronQuery.graphql";

export const AgendaScreen = () => {
  const route = useRoute<RouteProp<ClubStackNavigatorParamList, "Agenda">>();

  const { facilitySlug } = route.params ?? {};

  const [queryRef, loadQuery] =
    useQueryLoader<AgendaFromFacilityTypePatronQuery>(
      AgendaFromFacilityTypeQueryString
    );

  useEffect(() => {
    loadQuery({});
  }, [loadQuery, facilitySlug]);

  return (
    <Suspense fallback={<Loader />}>
      <StatusBar barStyle="dark-content" />
      {queryRef && <AgendaFromFacilityTypePatron sessionRef={queryRef} />}
    </Suspense>
  );
};
